import React, { useState } from "react";
import Select from "react-select";
import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import { Container, Form, Row, Col, Accordion } from "react-bootstrap";
import Table from "react-bootstrap/Table";

import {
  GetCompetencyCategoryList,
  DeleteRecords,
  getFilteredList,
} from "../../services/CompetencyCategoryService";
import { FetchFilterInfo } from "../../services/pendingService";
import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
} from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import PieChartsDasboard from "./PieChartsDasboard";
import CompetencyAssessment from "./CompetencyAssessment";

const MCQDasboards = () => {
  const [chartData, setChartData] = useState({
    series: [
      {
        name: "Weightage 1",
        data: [44, 55, 57, 56],
      },
      {
        name: "Weightage 2",
        data: [76, 85, 101, 98],
      },
      {
        name: "Weightage 3",
        data: [35, 41, 36, 26],
      },
      {
        name: "Weightage 4",
        data: [30, 50, 80, 15],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 5,
          borderRadiusApplication: "end",
        },
      },
      colors: ["#6793DB", "#A267DB", "#6771DB", "#67B6DB"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: ["Jan", "Feb", "Mar", "April"],
      },
      yaxis: {
        title: {
          //   text: "$ (thousands)",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: val => `$ ${val} thousands`,
        },
      },
    },
  });

  const options = [
    { label: "Apple" },
    { label: "Banana" },
    { label: "Grapes" },
    { label: "Mango" },
  ];

  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = selected => {
    setSelectedOption(selected);
    console.log("Selected:", selected);
  };

  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="tab-content" id="pills-tabContent">
          <div className="joblist-container create-vacancy main-pages-s breadcums">
            <Row className="mb-2 align-items-center">
              <Col lg="6" md="6" className="Joblist-column breadcums">
                <Link to="/dashboard">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />
                    MCQ Manager / MCQ Dashboard
                  </h5>
                </Link>
              </Col>
            </Row>

            <div className="joblist-card-color">
              <Row>
                <Col lg="6" md="6" className="Joblist-column">
                  <div className="funnel-charts-card mcq-dashboard">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="eligible-content">
                          <h3 className="d-flex align-items-center gap-2 heading-one">
                            Competency Insights
                          </h3>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="cards-section mcqdashboard p-2 position-relative">
                          <div className="card-funnel-mcq">
                            <div className="card-funnel-pu7">
                              <Select
                                options={options}
                                value={selectedOption}
                                onChange={handleChange}
                                placeholder="Competency"
                                isClearable
                              />
                            </div>
                            <div className="card-funnel-pu7">
                              <Select
                                options={options}
                                value={selectedOption}
                                onChange={handleChange}
                                placeholder="2025"
                                isClearable
                              />
                            </div>
                            <div className="card-funnel-pu7">
                              <Select
                                options={options}
                                value={selectedOption}
                                onChange={handleChange}
                                placeholder="Q1"
                                isClearable
                              />
                            </div>
                          </div>
                          <div id="chart">
                            <ReactApexChart
                              options={chartData.options}
                              series={chartData.series}
                              type="bar"
                              height={350}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="mcq-dashboard-cards">
                    <div className="tabs-container tabbing-wrapper">
                      {/* Tab Headers */}
                      <div className="tabs">
                        <ul className="tab-btn-wrapper d-flex align-items-center">
                          <li>
                            <Link
                              to="#"
                              className={
                                activeTab === "tab1"
                                  ? "tab-link active"
                                  : "tab-link"
                              }
                              onClick={() => setActiveTab("tab1")}
                            >
                              Top 5 Easy Question
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className={
                                activeTab === "tab2"
                                  ? "tab-link active"
                                  : "tab-link"
                              }
                              onClick={() => setActiveTab("tab2")}
                            >
                              Top 5 Difficult Question
                            </Link>
                          </li>
                        </ul>
                      </div>

                      {/* Tab Content */}
                      <div className="tab-content">
                        {activeTab === "tab1" && (
                          <div className="content-tabs-cards cards-section  mcqdash">
                            <div className="tabel-application table-responsive">
                              <div className="timeto-hire-card userlist">
                                <div className="table-custome-class range-custome">
                                  <div className="scroll-container">
                                    <div className="table-pending-list">
                                      <div className="table-wrapper">
                                        <div className="react-bootstrap-table">
                                          <Table striped bordered hover>
                                            <thead>
                                              <tr>
                                                <th className="text-start">
                                                  Question Preview
                                                </th>
                                                <th className="text-center">
                                                  Competencies <br />
                                                  Associated{" "}
                                                </th>
                                                <th className="text-center">
                                                  No of passing <br />
                                                  candidate
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  Please find correct image.
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>60%</span>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  What is your name? 5 75%
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>75%</span>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  What’s the best way to include
                                                  self
                                                  <br />
                                                  -development in your daily
                                                  routine? 5 80%
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>80%</span>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  What does situational
                                                  adaptability mean?
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>85%</span>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  Why is customer satisfaction
                                                  important?
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>70%</span>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {activeTab === "tab2" && (
                          <div className="content-tabs-cards cards-section mcqdash">
                            <div className="tabel-application table-responsive">
                              <div className="timeto-hire-card userlist">
                                <div className="table-custome-class range-custome">
                                  <div className="scroll-container">
                                    <div className="table-pending-list">
                                      <div className="table-wrapper">
                                        <div className="react-bootstrap-table">
                                          <Table striped bordered hover>
                                            <thead>
                                              <tr>
                                                <th>Question Preview</th>
                                                <th className="text-center">
                                                  Competencies <br />
                                                  Associated{" "}
                                                </th>
                                                <th className="text-center">
                                                  No of passing <br />
                                                  candidate
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  Please find correct image.
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>60%</span>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  What is your name? 5 75%
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>75%</span>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  What’s the best way to include
                                                  self
                                                  <br />
                                                  -development in your daily
                                                  routine? 5 80%
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>80%</span>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  What does situational
                                                  adaptability mean?
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>85%</span>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  Why is customer satisfaction
                                                  important?
                                                </td>
                                                <td className="text-center">
                                                  5
                                                </td>
                                                <td>
                                                  <span>70%</span>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="joblist-card-color-c">
              <Row>
                <Col lg="6" md="6" className="Joblist-column">
                  <div className="funnel-charts-card">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="eligible-content">
                          <h3 className="d-flex align-items-center gap-2 heading-one">
                            Assessment Insights
                          </h3>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="cards-section mcqdashboard p-2 position-relative">
                          <div className="card-funnel-mcq">
                            <div className="card-funnel-pu7">
                              <Select
                                options={options}
                                value={selectedOption}
                                onChange={handleChange}
                                placeholder="Assessment"
                                isClearable
                              />
                            </div>
                            <div className="card-funnel-pu7">
                              <Select
                                options={options}
                                value={selectedOption}
                                onChange={handleChange}
                                placeholder="2025"
                                isClearable
                              />
                            </div>
                            <div className="card-funnel-pu7">
                              <Select
                                options={options}
                                value={selectedOption}
                                onChange={handleChange}
                                placeholder="Q1"
                                isClearable
                              />
                            </div>
                          </div>

                          <PieChartsDasboard />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col lg={6} md={6}>
                  <div className="mcq-dashboard-cards">
                    <div className="tabs-container tabbing-wrapper">
                      {/* Tab Headers */}
                      <div className="col-lg-12">
                        <div className="eligible-content">
                          <h3 className="d-flex align-items-center gap-2 heading-one">
                            Time Spent on Assessment
                          </h3>
                        </div>
                      </div>

                      {/* Tab Content */}
                      <div className="tab-content">
                        <div className="content-tabs-cards cards-section p7profile">
                          <div className="tabel-application table-responsive">
                            <div className="timeto-hire-card userlist">
                              <div className="table-custome-class range-custome">
                                <div className="scroll-container">
                                  <div className="table-pending-list">
                                    <div className="table-wrapper  profile-table">
                                      <div className="react-bootstrap-table">
                                        <Table striped bordered hover>
                                          <thead>
                                            <tr>
                                              <th className="text-start">
                                                Profile Name
                                              </th>
                                              <th className="text-center">
                                                Min Time (Min)
                                              </th>
                                              <th className="text-center">
                                                Max Time (Min)
                                              </th>
                                              <th className="text-center">
                                                Average Time (Min)
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>Software Developer</td>
                                              <td className="text-center">
                                                15
                                              </td>
                                              <td>
                                                <span className="per">30</span>
                                              </td>
                                              <td>
                                                <span>20</span>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Jr Account Manager</td>
                                              <td className="text-center">
                                                15
                                              </td>
                                              <td>
                                                <span className="per">30</span>
                                              </td>
                                              <td>
                                                <span>20</span>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Sr. Business Analyst</td>
                                              <td className="text-center">
                                                15
                                              </td>
                                              <td>
                                                <span className="per">30</span>
                                              </td>
                                              <td>
                                                <span>20</span>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>React Native</td>
                                              <td className="text-center">
                                                15
                                              </td>
                                              <td>
                                                <span className="per">30</span>
                                              </td>
                                              <td>
                                                <span>20</span>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Jr Account Manager</td>
                                              <td className="text-center">
                                                15
                                              </td>
                                              <td>
                                                <span className="per">30</span>
                                              </td>
                                              <td>
                                                <span>20</span>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Sr. Business Analyst</td>
                                              <td className="text-center">
                                                15
                                              </td>
                                              <td>
                                                <span className="per">30</span>
                                              </td>
                                              <td>
                                                <span>20</span>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="joblist-card-color po">
              <Row>
                <Col lg={12}>
                  <CompetencyAssessment />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MCQDasboards;
